import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';

import { User }       from '../models'

@Injectable()
export class UserService {

  private user = new Subject<User>();
  readonly user$ = this.user.asObservable();

  changeUser(user: User) {
    this.user.next(user)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts